module.exports = __webpack_public_path__ + "img/none.ea32a5a7.png";